import Vue from "vue";
import App from "./App.vue";
import "@aws-amplify/ui-vue";
import Amplify from "aws-amplify";
import { Logger } from "@aws-amplify/core";
import { I18n } from "@aws-amplify/core";
import Auth from "@aws-amplify/auth";
import awsconfig from "./aws-exports";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";
import vueAwesomeCountdown from "vue-awesome-countdown";
import "@mdi/font/css/materialdesignicons.css";
import VueCookies from 'vue-cookies'
// import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag';

Vue.config.productionTip = false;

Amplify.configure(awsconfig);
applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.use(vueAwesomeCountdown, "vac");
Vue.use({ Auth, Logger, I18n });
Vue.config.productionTip = false;
Vue.use(VueCookies, { expires: '7d'})

console.log("main.js");

Vue.use(
  VueGtag,
  {
    bootstrap: false,
    config: {
      params: {
        send_page_view: true,
      },
    },
  },
  router
);

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
